export class ReportAgenciesBusquedaModel {
    fecha_captura_inicio: string;
    fecha_captura_fin: string;
    estado_aplicante: string;
    producto: string;
    promotor: string;
    area: string;    
}
